import React from 'react';
import {sx} from "./sx";
import SearchPointsFromPastVoyagesMutateSingleVoyage
    from "@containers/singleVoyage/mutateVoyage/points/searchPointsFromPastVoyages/SearchPointsFromPastVoyagesMutateSingleVoyage";
import PointsHelperIndicatorMutateSingleVoyage
    from "@containers/singleVoyage/mutateVoyage/points/pointsHelperIndicator/PointsHelperIndicatorMutateSingleVoyage";
import Stack from '@mui/material/Stack';
import ToRouteModeMutateSingleVoyage
    from "@containers/singleVoyage/mutateVoyage/route/toRouteMode/ToRouteModeMutateSingleVoyage";
import {
    useViewContextMutateSingleVoyage
} from "@containers/singleVoyage/mutateVoyage/context/viewContext/hooks/useViewContextMutateSingleVoyage";


const SidebarPointMutateSingleVoyage = () => {

    const {modeSecondarySidebar} = useViewContextMutateSingleVoyage()

    return (
        <Stack
            gap={'12px'}
            sx={sx.inner}
        >
            <SearchPointsFromPastVoyagesMutateSingleVoyage/>

            <PointsHelperIndicatorMutateSingleVoyage/>

            {modeSecondarySidebar !== 'route' && <>
                <ToRouteModeMutateSingleVoyage/>
            </>}

        </Stack>
    );
};

export default SidebarPointMutateSingleVoyage;